import type { Image, Media, MediaImage } from '@/types/shopify'

const MEDIA_QUERIES = [
  '(min-resolution: 3dppx)',
  '(min-resolution: 2dppx)',
  '(min-resolution: 1dppx)'
]

export const preloadImage = (src: string) => new Image().src = src

export const getDensityMultiplier = () => Math.max((MEDIA_QUERIES.findIndex(i => window.matchMedia(i).matches) + 1), 1)

export const assetUrl = (file: string) => {
  const origin = import.meta.env.DEV ? new URL(import.meta.url).origin : import.meta.url
  return new URL(file, origin).href
}

export const getImageUrl = (image: Image | Media | MediaImage) => {
  const src = ('url' in image ? image.url : image.src).replace(/_\d+x\./, '.')
  return getImageUrlFromSrc(src)
}

export const getImageUrlFromSrc = (src: string) => {
  return new URL(src.startsWith('//') ? `https:${src}` : src)
}

export const resizeImageUrl = (url: URL, width: number) => {
  url.searchParams.set('width', String(width))
  return url.toString()
}

export const useResponsiveImage = (image: Image | Media | MediaImage) => {
  const url = getImageUrl(image)
  const downscale = (size: number) => resizeImageUrl(url, size)
  return {
    url,
    downscale
  }
}
